<style>
.customer tr th,.customer tr td{
  padding:3px 0px 3px 0px;
}
.customer tr td{
  text-align:right
}
.customer tr th{
  color:#4caf50;
  font-weight: 500;
}
.customer tr td{
  font-weight: 600;
}
p{
  font-weight: 600;
}
.list-group li:first-child{
  border-left:solid 3px #4caf50;
}
.list-group li:first-child h5{
  color: #4caf50;
}
#phone_format button{
  padding: 2px 10px;
}
.custom_poppover{
  background: rgb(247 247 247);
  min-width:220px;
}
.list-group-item:hover.list-group-item{
  background: #4caf50;
}

</style>
<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import NotifyModal from "./widgets/notify_modal.vue";
import myMixin from '@/helpers/helperMixin' 
import { ability } from '@/helpers/helper' 
import UpdateModal from './widgets/update_info'

export default {
  page: {
    title: "Müşteri Detay",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader,NotifyModal,UpdateModal },
  mixins: [myMixin],
  data() {
    return {
      collapse:false,
      routeParams: this.$route.params,
      selectData:{},
      data:{},
      list:{},
      subsId:0,
      paramId: 0,
      updateData: 0,
      paramCustomerId: 0,
      title: "MÜŞTERİ DETAY",
      subscriptions:[],
      orginal_subscriptions:[],
      notifies:[],
      items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "MÜŞTERİ LİSTESİ",
          href: "/",
        },
        {
          text: "MÜŞTERİ DETAY",
          active: true,
        },
      ],
      tabList: [
        { title: 'Özet', route: 'ozet', key:'ozet' },
        { title: 'Faturalar', route: 'faturalar', key:'fatura-listesi' },
        { title: 'Evraklar', route: 'evraklar', key:'evrak-listesi' },
        { title: 'Servis Kayıtları', route: 'arizalar', key:'ariza-listesi' },
        { title: 'Santral', route: 'santral', key:'santral' },
        { title: 'Sms', route: 'sms', key:'sms-listesi' },
        { title: 'Aktivite', route: 'aktivite', key:'aktivite-listesi' },
      ],
    };
  },
  computed:{
      tabs(){
        const kriterlereUyanSatirlar = [];
        for (let i = 0; i < this.tabList.length; i++) {
          const tab = this.tabList[i];
          if (this.checkRole(tab.key)) {
            kriterlereUyanSatirlar.push(tab);
          }
        }
        return kriterlereUyanSatirlar;
      }
  },
  methods:{
    searchSubscribe(event){
      const { value }  = event.target
      let data = [];
      this.orginal_subscriptions.map(e=> { 
          if(e.username.indexOf(value)  > -1)
            data.push(e);
        })
      this.subscriptions = data
    },
    findAndTop(subscription, oldIndex){
      this.paramId = subscription.id
      this.selectData =  this.data.subscribers.find(e=> e.id == subscription.id)
      this.subscriptions.splice(oldIndex, 1); // 2nd parameter means remove one item only
      this.subscriptions = [subscription].concat(this.subscriptions)
    },
    async changeUsername(subscription, oldIndex){
      await this.findAndTop(subscription, oldIndex);
      const { id } = this.$route.params
      if(subscription.id == id) return
     
      this.$router.push({ name:'ozet', params: { uuid: this.routeParams.uuid, id: subscription.id  }})
    },
    addNotify(){
      this.list = {}
      this.$bvModal.show('notify_modal')
    },
    listNotify(){
      const { id } = this.$route.params
      const notifyUrl = `/members/${id}/notify`
      this.$http.post(notifyUrl)
      .then(resp => this.notifies = resp.data)
    },
    updateNotify(props){
      this.list = props
      this.$bvModal.show('notify_modal')
    },
    addSubscribe(){
      this.$router.push({name: 'abone-ekle' , params: { id:this.paramCustomerId}})
    },
    goCustomerUpdate(){
      if(this.paramId <1) return 
      this.updateData = this.paramId
      this.$bvModal.show('update_model')
    },
    checkRole(role){
      if(!role) return
      if(role == 'ozet') return true

      return ability(role)
    }
  },
  created(){
    const { uuid,id } = this.$route.params
    const url = `/members/${uuid}`
    this.paramId = id // id ve uuid gelecek

    this.$http.post(url)
      .then(resp => {
        this.paramCustomerId = resp.data.id // id ve uuid gelecek
        resp.data.subscribers.map(e=>{
          this.subscriptions.push({id:e.id, username:e.username, address:e.address, service_num:e.service_num, neighbourhood:e.neighbourhood})
          this.orginal_subscriptions.push({id:e.id, username:e.username, address:e.address, service_num:e.service_num, neighbourhood:e.neighbourhood})
        })
        
        const index = resp.data.subscribers.findIndex(e => {
          return e.id == this.paramId;
        });

        //this.notifies = resp.data.notifies
        this.data = resp.data;
        this.selectData =  resp.data.subscribers[index]
        this.findAndTop(this.selectData,index);
    })
  },
  mounted(){
    document.body.classList.toggle("vertical-collpsed");
    this.$http.get('/group/search')
    .then(resp => this.selectData['groupList'] = resp.data.content )
      
    this.$http.get('/dealers/search?output=json')
    .then(resp => this.selectData['bayiList'] = resp.data )
  },
};
</script>

<template>
  <Layout>

    <PageHeader :title="title" :items="items" />
    <NotifyModal :list="list" @loadItems="listNotify" />
    <UpdateModal :subs="updateData" />

    <div class="row">
        <div class="col-xl-4">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex align-items-start">
                        <div class="w-100">
                          <h4 class="my-0" v-if="data.type == 'k'">{{ data.companyname }} </h4>
                          <h4 class="my-0" v-else>{{ data.fname }} {{ data.lname }} </h4>
                          <div class="responsive-table mt-4">
                            <table class="customer table">
                              <tbody>
                                <tr>
                                  <th>Ekleyen</th>
                                    <td v-if="data.subscribers">{{ data.subscribers[0].created_name }}</td>
                                    <td v-else>Bilinmiyor</td>
                                </tr>
                                <tr>
                                  <th>Bayi</th><td>{{ data.dealer_name }}</td> 
                                </tr>
                                <tr>
                                  <th> Müşteri Tipi</th><td>{{ data.musteri_tipi }}</td>
                                </tr>
                                <tr v-if="data.type == 'b'">
                                  <th> Tc</th><td>{{ data.tc }}</td>
                                </tr>
                                <tr v-if="data.type == 'k'">
                                  <th> Yetkili İsim</th><td>{{ data.fname }}</td>
                                </tr>
                                 <tr v-if="data.type == 'k'">
                                  <th> Yetkili Soyisim</th><td>{{ data.lname }}</td>
                                </tr>
                                 <tr v-if="data.type == 'k'">
                                  <th> Yetkili Tc</th><td>{{ data.tc }}</td>
                                </tr>
                                <tr> 
                                  <th> Email</th><td>{{ data.email }}</td>
                                </tr>
                                <tr>
                                  <th> 
                                    Telefon 1 
                                  </th>
                                  <td>  
                                    <div class="btn-group" id="phone_format">
                                      <button type="button" @click.prevent="copyURL(data.phonenumber)"  class="btn btn-outline-secondary">
                                         {{ data.phonenumber }}  <i class="mdi mdi-content-copy text-success"></i></button>
                                      <button type="button" class="btn btn-outline-success"><i class="mdi mdi-whatsapp"></i></button>
                                      <button type="button" class="btn btn-outline-primary"><i class="mdi mdi-phone"></i></button>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <th> Telefon 2</th><td>{{ data.phonenumber2 }}</td>
                                </tr>
                                 <tr>
                                  <th>ikamet Adresi</th><td>{{ data.address }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                            <!--<div style="background:#d3d3d33d;border-radius:20px;text-align:center;font-size:10px;cursor:pointer" @click="collapse = !collapse">
                              <span v-if="collapse">
                                 <i class="mdi mdi-arrow-collapse-up"></i> Daralt
                              </span>
                              <span v-else>
                                 <i class="mdi mdi-arrow-collapse-down"></i> Genişlet
                              </span>
                            </div>-->
                        </div>
                        <div class="float-end">
                          <a href="#" @click.prevent="goCustomerUpdate(data)">
                              <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                          </a>
                      </div>
                    </div>  
                </div>                                 
            </div> <!-- end card -->
            <div class="fieldset">
              <div class="legend">Abonelikleri </div>
                <div class="d-flex justify-content-between mb-2">
                  <div class="col-md-10 me-3">
                    <input type="text" @keyup="searchSubscribe($event)" class="form-control" placeholder="Abonelikler'de Ara">
                  </div>
                  <div class="col">
                    <button class="btn btn-block btn-sm btn-light" v-b-tooltip.hover.top title="Yeni Abonelik Ekle" @click.prevent="addSubscribe()">
                      <i class="mdi mdi-plus text-success font-size-16"></i> Yeni
                    </button>
                  </div>
                </div>
                <ul class="list-group">
                  <li 
                    style="cursor:pointer"
                    class="list-group-item pt-1 py-0 bg-transparent"
                    v-for="(subscription, index) in subscriptions" 
                    :key="subscription.id" 
                    
                  >
                    <b-popover :target="`popover${index}`" triggers="hover focus" placement="bottom" :arrow="true" custom-class="custom_poppover">
                      <div class="responsive-table">
                        <table class="table table-sm mb-0">
                          <tbody>
                            <tr>
                              <th> Adres</th><th>:</th><td>{{ subscription.address }}</td> 
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-popover>
                  
                    <div class="d-flex align-items-center" 
                    @click="changeUsername(subscription,index)">
                        <div class="w-100">
                            <h5 :id="`popover${index}`">{{ subscription.service_num }} ( {{ subscription.neighbourhood }} )</h5>
                        </div>
                        <i class="mdi mdi-chevron-right h2"></i>
                    </div>
                  </li>
              </ul>
            </div>
            <div class="fieldset">
              <div class="legend">Notlar </div>
                <div class="list-group" v-if="notifies && notifies.length == 0 ">
                 <button class="btn btn-block btn-sm btn-light" v-b-tooltip.hover.top title="Not Ekle" @click.prevent="addNotify()" v-if="checkRole('not-ekle')">
                        <i class="mdi mdi-plus text-success font-size-16"></i> Yeni Ekle
                  </button>
                  <div class="no-result"></div>
                </div>
                <div v-else-if="checkRole('not-listesi')">
                  <div class="d-flex justify-content-between mb-2">
                    <div class="col-md-10 me-3">
                      <input type="text" class="form-control" placeholder="Notlar'da Ara">
                    </div>
                    <div class="col">
                      <button class="btn btn-block btn-sm btn-light" v-b-tooltip.hover.top title="Not Ekle" @click.prevent="addNotify()" v-if="checkRole('not-ekle')">
                        <i class="mdi mdi-plus text-success font-size-16"></i> Yeni
                      </button>
                    </div>
                  </div>
                
                  <div class="list-group">
                      <a href="#" class="my-1" v-for="noty in notifies" :key="noty.id">
                        <div class="d-flex align-items-start">
                            <div class="w-100 ms-2">
                                <h5 class="mb-1 mt-0 d-flex justify-content-between">{{ noty.content}} 
                                  <span class="font-11">
                                     <i @click.prevent="updateNotify(noty)" class="mdi mdi-circle-edit-outline ms-1 text-success"></i>
                                  </span>
                                </h5>
                                <ul class="list-inline text-muted font-12">
                                    <li class="list-inline-item" >
                                      <i class="mdi mdi-calendar-blank-outline me-1"></i>{{ noty.created_at}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                      </a>
                  </div>
                </div>
            </div>
        </div> <!-- end col-->
        <div class="col-xl-8">
            <div class="card1">
               <ul class="own-wizard nav nav-pills nav-justified" role="tablist">
                  <li
                    v-for="(tab,i) in tabs"
                    :key="i"
                    role="presentation"
                    class="nav-item"
                  >
                    <router-link
                      :to='{ name: tab.route  }'
                      class="nav-link"
                      active-class="current"
                      exact
                    > 
                      <span class="font-weight-bold">{{ tab.title }}</span>
                    </router-link>
                   </li> 
                </ul>
            </div> <!-- end card-->
            <router-view :data="selectData" />
        </div> <!-- end col -->
    </div>
    <!-- end row-->
  </Layout>
</template>